import React, { useState, useEffect } from "react";
import UserPageLayout from "../../../../../../components/UserPageLayout";
import Earning from "../../components/earning";
import { useAppContext } from "../../../../../../../../context/AppContext";
import { decodeId } from "../../../../../../../../utils/hash";
import { useParams, useLocation } from "react-router-dom";
import Withdrawals from "../../components/withdrawals";
import WithdrawFunds from "../../components/withdraw";



export default function Earnings() {
    const { setPageTitle, setPageUserID } = useAppContext();

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const page = queryParams.get("page") ? decodeId(queryParams.get("page")) : null;


    const { id } = useParams();
    const userId = id ? decodeId(id) : null;


    const [activeTab, setActiveTab] = useState("earnings");

    useEffect(() => {
        setPageUserID(userId);
        setPageTitle("Partner");

        if (page && page === 67788776) {
            setActiveTab("withdrawals");
        } else {
            setActiveTab("earnings");
        }

    }, [setPageTitle, setPageUserID, userId, page]);
    const [reload, setReload] = useState(false);
    return (
        <UserPageLayout>

            <div className="content-body">
                <div className="container-fluid">
                    {activeTab === "earnings" && (<Earning userId={userId} setActiveTab={setActiveTab} reload={reload} setReload={setReload} />)}
                    {activeTab === "withdrawals" && (
                        <>
                            { !userId && <WithdrawFunds setActiveTab={setActiveTab} reload={reload} setReload={setReload} /> }
                            <h1 className=" m-4">Withdrawals</h1>
                            <Withdrawals userId={userId} setActiveTab={setActiveTab} reload={reload}  />
                        </>

                    )}
                </div>
            </div>
        </UserPageLayout>
    );
}